import { useTheme } from "arkh";
import React from "react";
import { Platform } from "react-native";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { HeaderButton } from "../../../../components";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { UserLoggedInNavigator } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigator";
import { WANoteIntegration } from "./WidgetNoteIntegration/WANoteIntegration";
import { WAKPI } from "./WidgetKPI/WAKPI";
import { WANote } from "./WidgetNote/WANote";
import { WAPushAppy } from "./WidgetPushAppy/WAPushAppy";
import { WATaskCollection } from "./WidgetTaskCollection/WATaskCollection";
import { WATaskSingle } from "./WidgetTaskSingle/WATaskSingle/WATaskSingle";
import { WATeamSchedule } from "./WidgetTeamSchedule/WATeamSchedule";
import { WAWeather } from "./WidgetWeather/WAWeather";
import { WidgetAdd } from "../WidgetAdd/WidgetAdd";

import { WATodoCategory } from "./WidgetTodoOverview/WATodoOverview";
import { WSTodoOverview } from "./WidgetTodoOverview/WSTodoOverview";
import { WSChecklistOverview } from "./WidgetChecklistOverview/WSChecklistOverview";
import { WSTaskCollection } from "./WidgetTaskCollection/WSTaskCollection";
import { WSTaskSingle } from "./WidgetTaskSingle/WSTaskSingle";
import { WAEmployeeSchedule } from "./WidgetEmployeeSchedule/WAEmployeeSchedule";
import { WSEmployeeSchedule } from "./WidgetEmployeeSchedule/WSEmployeeSchedule";
import { WSCalendarOverview } from "./WidgetCalendarOverview/WSCalendarOverview";
import { WASignalOverview } from "./WidgetSignalOverview/WASignalOverview";
import { WSSignalOverview } from "./WidgetSignalOverview/WSSignalOverview";
import { WAEmployeeRoleOverview } from "./WidgetEmployeeRoleOverview/WAEmployeeRoleOverview";
import { WSEmployeeRoleOverview } from "./WidgetEmployeeRoleOverview/WSEmployeeRoleOverview";

import { WANoteExisting } from "./WidgetNote/WANoteExisting";
import { WAIntegrationTurnpike } from "./WidgetIntegrationTurnpike/WAIntegrationTurnpike";
import { WACalendar } from "./WidgetCalendar/WACalendar";
import { webModalOptions } from "@/src/TopLevelNavigators/UserLoggedIn/WEB_MODAL_DEFAULT_WIDTH";
import { WSNote } from "./WidgetNote/WSNote";
import { WSFileStack } from "./WidgetFile/WSFileStack";
import { WAFileStack } from "./WidgetFile/WAFileStack";
import { WAFlourishPraise } from "./WidgetIntegrationFlourishPraise/WAIntegrationFlourishPraise";
import { WAIntegrationKPI } from "./WidgetIntegrationKPI/WAIntegrationKPI";
import { WATodoSummary } from "./WidgetTodoSummary/WATodoSummary";
import { WSTodoSummary } from "./WidgetTodoSummary/WSTodoSummary";
import { WAIntegrationNewsfeed } from "./WidgetIntegrationNewsfeed/WAIntegrationNewsfeed";
import { WAIntegrationList } from "./WidgetIntegrationList/WAIntegrationList";
import { WAIntegrationTable } from "./WidgetIntegrationTable/WAIntegrationTable";
import { WAEmployeeLeave } from "./WidgetEmployeeLeave/WAEmployeeLeave";
import { WSEmployeeLeave } from "./WidgetEmployeeLeave/WSEmployeeLeave";
import { WACalendarOverview } from "./WidgetCalendarOverview/WACalendarOverview";

export function useWidgetNavigationScreens() {
  const intl_tokens = useIntlTokens();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const theme = useTheme();
  return (
    <>
      <UserLoggedInNavigator.Screen
        name="WidgetAdd"
        component={WidgetAdd}
        options={({ navigation, route }) => {
          const routes = navigation.getState()?.routes;
          const gestureEnabled =
            isCompact &&
            (routes?.[routes?.length - 1]?.state?.index ?? 0) === 0;
          return {
            presentation: "modal",
            gestureEnabled,
            headerShown: false,
            ...webModalOptions,
          };
        }}
      />
      <UserLoggedInNavigator.Group
        screenOptions={({ navigation }) => ({
          headerShown: isCompact,
          headerStyle: {
            backgroundColor: theme["surface-primary"],
          },
          headerShadowVisible: false,
          headerStatusBarHeight: 0,
          headerLeft:
            Platform.OS === "ios"
              ? () => <HeaderButton type="CANCEL" onPress={navigation.goBack} />
              : undefined,
          gestureEnabled: false,
          title: "",
          ...webModalOptions,
        })}
      >
        <UserLoggedInNavigator.Screen
          name="WSFile"
          component={WSFileStack}
          options={{
            headerShown: false,
          }}
        />

        <UserLoggedInNavigator.Screen
          name="WSEmployeeSchedule"
          component={WSEmployeeSchedule}
        />
        <UserLoggedInNavigator.Screen
          name="WSEmployeeLeave"
          component={WSEmployeeLeave}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSNote"
          component={WSNote}
          options={{ headerShown: false }}
        />
        <UserLoggedInNavigator.Screen
          name="WSTaskSingle"
          component={WSTaskSingle}
        />
        <UserLoggedInNavigator.Screen
          name="WSTaskCollection"
          component={WSTaskCollection}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSTodoOverview"
          component={WSTodoOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />

        <UserLoggedInNavigator.Screen
          name="WSTodoSummary"
          component={WSTodoSummary}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSChecklistOverview"
          component={WSChecklistOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSSignalOverview"
          component={WSSignalOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSCalendarOverview"
          component={WSCalendarOverview}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddWeather"
          component={WAWeather}
          options={{
            title: intl_tokens.SelectLocation,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddKPI"
          component={WAKPI}
          options={{
            title: intl_tokens.SelectMeasurementAreas,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddNote"
          component={WANote}
          options={{
            title: intl_tokens.SetTitle,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddNoteExisting"
          component={WANoteExisting}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddTeamSchedule"
          component={WATeamSchedule}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddTodoCategory"
          component={WATodoCategory}
          options={{
            title: intl_tokens.CustomiseYourWidget,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddEmployeeLeave"
          component={WAEmployeeLeave}
          options={{
            headerShown: false,
          }}
        />

        <UserLoggedInNavigator.Screen
          name="WidgetAddTodoSummary"
          component={WATodoSummary}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddTaskSingle"
          component={WATaskSingle}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddTaskCollection"
          component={WATaskCollection}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddEmployeeSchedule"
          component={WAEmployeeSchedule}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddCalendarOverview"
          component={WACalendarOverview}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddCalendar"
          component={WACalendar}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddNoteIntegration"
          component={WANoteIntegration}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationTurnpike"
          component={WAIntegrationTurnpike}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddPushAppy"
          component={WAPushAppy}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationFlourishPraise"
          component={WAFlourishPraise}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddFile"
          component={WAFileStack}
          options={{
            headerShown: false,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationKPI"
          component={WAIntegrationKPI}
          options={{}}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationNewsfeed"
          component={WAIntegrationNewsfeed}
          options={{}}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationList"
          component={WAIntegrationList}
          options={{}}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddIntegrationTable"
          component={WAIntegrationTable}
          options={{}}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddSignals"
          component={WASignalOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WSEmployeeRoleOverview"
          component={WSEmployeeRoleOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
        <UserLoggedInNavigator.Screen
          name="WidgetAddEmployeeRoles"
          component={WAEmployeeRoleOverview}
          options={{
            title: intl_tokens.SelectTeams,
          }}
        />
      </UserLoggedInNavigator.Group>
    </>
  );
}
